// convert salesforce -> Salesforce
export function formatProviderNames(name) {
    return name.charAt(0).toUpperCase() + name.slice(1);
}
export const getProviderByProviderType = (providerType) => {
    const providerMap = {
        QuickBooksSandbox: 'quickbooks',
        QuickBooks: 'quickbooks',
        Salesforce: 'salesforce',
        HubSpot: 'hubspot',
        MsEntra: 'msentra',
        Redtail: 'redtail',
        Wealthbox: 'wealthbox',
        MFiles: 'mfiles',
        Outlook: 'outlook',
        Alts: 'alts',
        ApexClearing: 'apexclearing',
        GoldmanSachs: 'goldmansachs',
        BillCom: 'billcom',
        Schwab: 'schwab',
        Orion: 'orion',
        SalesforceClientCredentials: 'salesforceclientcredentials'
    };
    return providerMap[providerType];
};
export const sendLogoutMessage = (id) => {
    window.postMessage({ type: 'logout', id });
};
export const sendLoginMessage = (id) => {
    window.postMessage({ type: 'login', id });
};
export const openLoginModal = (configurationId) => {
    window.dispatchEvent(new CustomEvent('open-auth-modal', { detail: configurationId }));
};
